<template>
  <div class="user-details">
    <v-list-item v-for="(item, index) in details" :key="index" class="px-0">
      <v-list-item-content class="py-0 pt-1">
        <v-list-item-title class="caption font-weight-bold">{{
          item.label
        }}</v-list-item-title>
        <v-list-item-subtitle v-if="item.isLink">
          <ButtonTooltip
            v-if="userDetails.zohoId"
            icon
            x-small
            color="primary"
            target="_blank"
            :href="item.link"
            :tooltip-text="item.tooltip"
            :tooltip-props="{ bottom: false, right: true }"
            >{{ item.icon }}</ButtonTooltip
          >
        </v-list-item-subtitle>
        <v-list-item-subtitle v-else>{{ item.value }}</v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
  </div>
</template>

<script>
import ButtonTooltip from "@evercam/shared/components/ButtonTooltip.vue"

export default {
  components: { ButtonTooltip },
  props: {
    userDetails: {
      type: Object,
      required: true,
    },
  },
  computed: {
    details() {
      return [
        {
          label: "Email",
          value: this.userDetails.email,
        },
        {
          label: "# Projects",
          value: this.userDetails.projectsCount,
        },
        {
          label: "# Cameras",
          value: this.userDetails.camerasCount,
        },
        {
          label: "Last seen",
          value: this.userDetails.lastEventCreatedAt,
        },
        {
          label: "Last seen browser",
          value:
            this.userDetails.lastEventBrowser && this.userDetails.lastEventOs
              ? `${this.userDetails.lastEventBrowser} on ${this.userDetails.lastEventOs}`
              : "-",
        },
        {
          label: "Last seen IP",
          value: this.userDetails.lastEventIpAddress,
        },
        {
          label: "Zoho Link",
          tooltip: "Open Zoho Account",
          link: `${this.$config.public.zohoCrmUrl}/tab/Contacts/${this.userDetails.zohoId}`,
          isLink: !!this.userDetails.zohoId,
          value: " - ",
          icon: "Z",
        },
      ]
    },
  },
}
</script>

<style lang="scss">
.user-details {
  display: flex;
  flex-wrap: wrap;
  .v-list-item {
    margin-bottom: 5px;
    min-height: 0px !important;
    flex: 1 1 30%;
  }
}
</style>
